import { useEffect, useState } from "react";

// True while the on-screen keyboard is up in the native app. The Capacitor
// Keyboard plugin fires these on `window` itself (no plugin import, nothing
// to await — see reference: never await a Capacitor plugin proxy); on the
// web the events never fire and this stays false. Used by the tab bars: the
// webview shrinks for the keyboard (Keyboard.resize = native, see
// capacitor.config.ts), so a fixed bottom bar would otherwise ride up and sit
// on top of the keyboard.
export function useKeyboardOpen(): boolean {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const show = () => setOpen(true);
    const hide = () => setOpen(false);
    window.addEventListener("keyboardWillShow", show);
    window.addEventListener("keyboardWillHide", hide);
    return () => {
      window.removeEventListener("keyboardWillShow", show);
      window.removeEventListener("keyboardWillHide", hide);
    };
  }, []);
  return open;
}
